/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function (exports) {
    'use strict';

    var util = MoyaContainer.get('core.util');
    MoyaComponents.register('one.filter', function (el) {
        var filterConfig = {
            selectElm: el.querySelector('select'),
        };
        var filter = new OneFilter(filterConfig);
        filter.run();
    });
    var OneFilter = /** @class */ (function () {
        function OneFilter(config) {
            this.selectElm = config.selectElm;
        }
        OneFilter.prototype.run = function () {
            util.delegate(this.selectElm, 'input', 'select', function (e) {
                var target = e.target;
                window.location.href = target.value;
            });
        };
        return OneFilter;
    }());

    exports.OneFilter = OneFilter;

    return exports;

}({}));
typeof tsBuild === 'function' && tsBuild();})();
